import { Navigate, RouteProps } from "react-router-dom";

import { useAuthContext } from "[root]/src/contexts";
import { MGRoutes } from "[root]/src/lib";
import { Overlay } from "../components";

type NoAuthProps = RouteProps & {
  children: JSX.Element;
  redirectTo?: string;
};

export const NoAuth = ({
  children,
  redirectTo = MGRoutes.dashboard,
}: NoAuthProps): JSX.Element | null => {
  const { session, loading } = useAuthContext();

  // Show nothing or a loading indicator while the session is being loaded
  if (loading) {
    return <Overlay />;
  }

  const isAuthenticated = !!session?.token && !!session?.refreshToken;

  return isAuthenticated ? <Navigate to={redirectTo} /> : children;
};
